import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonPasswordService, InfoPassword } from '@umanforge/common';

import { Input } from '../inputs/input.component';
import { Button } from '../inputs/button.component';

interface ChangePasswordProps {
  title?: string;
  subtitle?: string;
  buttonText: string;
  onClick: ( password: string ) => Promise<void>;
}

const PLACEHOLDER_PASSWORD = 'ZhP270j9${r%';


export const ChangePasswordComponent = ( { title, subtitle, buttonText, onClick }: ChangePasswordProps ) => {
  const passwordService = new CommonPasswordService();
  const { t } = useTranslation();

  const [ password, setPassword ] = useState<string>( '' );
  const [ passwordBis, setPasswordBis ] = useState<string>( '' );

  const [ isBusy, setIsBusy ] = useState<boolean>( false );
  const [ canSendPassword, setCanSendPassword ] = useState<boolean>( false );
  const [ constraintsPassword ] = useState<InfoPassword[]>(
    passwordService.passwordSchema.properties
      .filter( item => { return [ 'min', 'min', 'max', 'uppercase', 'lowercase', 'digits', 'symbols' ].includes( item.method ); } )
      .map( item => { return { validation: item.method, arguments: item.arguments[ 0 ], message: item.arguments[ 1 ] } as InfoPassword; } )
      .concat( [ passwordService.SamePasswordSchema ] )
  );
  const [ resultConstraintsPassword, setResultConstraintsPassword ] = useState<InfoPassword[]>(
    passwordService.validatePassword( password )
  );

  useEffect( () => {
    const resultValidatePassword = passwordService.validatePassword( password );
    if ( password != passwordBis || password === '' ) {
      resultValidatePassword.push( passwordService.SamePasswordSchema );
    }
    setResultConstraintsPassword( resultValidatePassword );
    setCanSendPassword( resultValidatePassword.length === 0 );
  }, [ password, passwordBis ] );


  const onSavePassword = async () => {
    setIsBusy( true );
    if ( canSendPassword ) {
      await onClick( password );
    }
    setIsBusy( false );
  };

  return (
    <div>
      <div className='flex flex-col gap-4 mx-4'>
        <div className='flex flex-col gap-4 w-full'>
          <p className='text-xl text-center font-bold'> { title } </p>
          <i className='text-sm'> { subtitle } </i>
        </div>
        <div className="flex flex-col gap-4">
          <Input
            label={ t( 'Password' ) }
            placeholder={ PLACEHOLDER_PASSWORD }
            isPassword={ true }
            onChange={ setPassword }
            value={''}
          />
          <Input
            label={ t( 'Confirm password' ) }
            placeholder={ PLACEHOLDER_PASSWORD }
            isPassword={ true }
            onChange={ setPasswordBis }
            value={''}
          />
        </div>
        <div className='text-xs text-left mx-1' >
          {
            constraintsPassword.map( constraint => {
              return (
                <div
                  key={ constraint.validation }
                  className='flex flex-cols pt-[2px] items-center gap-1'
                >
                  {
                    (
                      resultConstraintsPassword.find( resultContraint => { return resultContraint.validation === constraint.validation; } ) ?
                        <svg
                          className='w-3 h-3 fill-error'
                          viewBox='0 0 384 512'
                        >
                          <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                        </svg>
                        :
                        <svg
                          className='w-3 h-3 fill-validate'
                          viewBox='0 0 448 512'
                        >
                          <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                        </svg>
                    )
                  }
                  <p className={
                    (
                      resultConstraintsPassword.find( resultContraint => { return resultContraint.validation === constraint.validation; } ) ?
                        'text-error'
                        :
                        'text-validate'
                    )
                  }>
                    {
                      t( constraint.message.replace( '{plural}', constraint.arguments > 1 ? 's' : '' ) )
                        .replace( '{0}', String( constraint.arguments ) )
                    }
                  </p>
                </div>
              );
            } )
          }
        </div>
        <div className='flex justify-center w-full'>
          <div className='min-w-[150px] h-9'>
            <Button
              label={ buttonText }
              onClick={ onSavePassword }
              disable={ isBusy || !canSendPassword }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
